import { c as _c } from "react/compiler-runtime";
import React from 'react';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import JBImage from 'components/essentials/JBImage';
import featuredInLogos from './featuredInLogos';
const FeaturedIn = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="text-2xl text-gray mx-auto my-0 pt-0 px-0 pb-[30px] font-bold md:text-center">As seen in</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-gray-light8 pt-[30px] px-0 pb-[50px] print:hidden"><FixedWidthContainer>{t0}<div className="grid gap-[20px] grid-cols-[repeat(auto-fit,minmax(20%,1fr)_)] md:grid-cols-[repeat(auto-fit,minmax(10%,1fr)_)]">{featuredInLogos.map(_temp)}</div></FixedWidthContainer></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default FeaturedIn;
function _temp(src) {
  return <div className="flex items-center justify-center [&_img]:w-20 [&_img]:h-10 [&_img]:object-contain" key={src}><JBImage className="featured-in__img" src={src} sizes="100vw" /></div>;
}